module.exports = __webpack_public_path__ + "img/hr-rock-huge-18.67d1a4fa.png";